import { CONFIG } from '@/core/config';

export function redirectToLogin() {
  if (import.meta.env.MODE === 'msw') {
    return;
  }

  globalThis.location.replace(
    `${CONFIG.APPS_SERVER}/login?redirectUrl=${globalThis.location.href}`,
  );
}

export function redirectToRadDashboard() {
  globalThis.location.replace(`${CONFIG.APPS_BASE_URL}/radiologist/dashboard`);
}
